<template>
  <!-- 车辆详情弹框 -->
  <a-modal
      :visible="visible"
      :footer="null"
      width="1100px"
      @cancel="handleCancel"
      @update:visible="(value) => emit('update:visible', value)"
  >
    <div class="vehicle-detail-container">
      <div class="vehicle-edit-section">
        <!-- 基本信息 -->
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.manufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">车辆型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.model || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">车辆种类：</span>
            <span class="vehicle-detail-value">
              {{ vehicle.type ? props.vehicleTypeList.find(item => item.id === vehicle.type)?.name : '-' }}
            </span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">车辆识别代号(VIN)：</span>
            <span class="vehicle-detail-value">{{ vehicle.vin || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">发动机号：</span>
            <span class="vehicle-detail-value">{{ vehicle.engineNumber || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">车身颜色：</span>
            <span class="vehicle-detail-value">{{ vehicle.color || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">生产日期：</span>
            <span class="vehicle-detail-value">{{ vehicle.productionDate || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">最大设计总质量(kg)：</span>
            <span class="vehicle-detail-value">{{ vehicle.maxDesignMass || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">整车整备质量(kg)：</span>
            <span class="vehicle-detail-value">{{ vehicle.curbWeight || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">轴荷(kg)：</span>
            <span class="vehicle-detail-value">{{ vehicle.axleLoad || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">额定载客人数：</span>
            <span class="vehicle-detail-value">{{ vehicle.ratedPassengerCapacity || '-' }}</span>
          </div>
        </div>
        
        <!-- 动力相关 -->
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力型式：</span>
            <span class="vehicle-detail-value">{{ vehicle.powerType || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力型式生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.powerTypeManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">发动机型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.engineModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">发动机型号生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.engineModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力蓄电池型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.batteryModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力蓄电池生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.batteryModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力电机型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.motorModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">动力电机生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.motorModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">驱动型式：</span>
            <span class="vehicle-detail-value">{{ vehicle.driveType || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">驱动型式生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.driveTypeManufacturer || '-' }}</span>
          </div>
        </div>
        
        <!-- 系统相关 -->
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">变速器型式：</span>
            <span class="vehicle-detail-value">{{ vehicle.transmissionType || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">变速器生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.transmissionTypeManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">行车制动系统型式：</span>
            <span class="vehicle-detail-value">{{ vehicle.brakeSystemType || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">行车制动系统生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.brakeSystemTypeManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">转向系统型式：</span>
            <span class="vehicle-detail-value">{{ vehicle.steeringSystemType || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">转向系统生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.steeringSystemTypeManufacturer || '-' }}</span>
          </div>
        </div>
        
        <!-- ADAS相关 -->
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ESC型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.escModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ESC生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.escModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ACC型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.accModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ACC生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.accModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">AEB型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.aebModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">AEB生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.aebModelManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">LKA型号：</span>
            <span class="vehicle-detail-value">{{ vehicle.lkaModel || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">LKA生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.lkaModelManufacturer || '-' }}</span>
          </div>
        </div>
        
        <!-- 其他信息 -->
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">轮胎规格：</span>
            <span class="vehicle-detail-value">{{ vehicle.tireSpec || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">轮胎生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.tireSpecManufacturer || '-' }}</span>
          </div>
        </div>
        <div class="vehicle-edit-row">
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ECU版本号：</span>
            <span class="vehicle-detail-value">{{ vehicle.ecuVersion || '-' }}</span>
          </div>
          <div class="vehicle-detail-item">
            <span class="vehicle-detail-label">ECU生产企业：</span>
            <span class="vehicle-detail-value">{{ vehicle.ecuVersionManufacturer || '-' }}</span>
          </div>
        </div>
      </div>

    </div>
  </a-modal>
</template>

<script setup name="VehicleDetailModal">
import { defineProps, defineEmits, computed } from 'vue';
import useAppStore from "@/store/modules/app";

const appStore = useAppStore();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  vehicleTypeList: {
    type: Array,
    default: () => ([])
  },
  vehicle: {
    type: Object,
    default: () => ({})
  },
  deptName: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:visible']);

// 处理取消事件
const handleCancel = () => {
  emit('update:visible', false);
};

// 从store中获取系统字典列表
const sysDictVOList = computed(() => appStore.SysDictVOList);
</script>

<style scoped>
.vehicle-detail-container {
  padding: 0 20px;
}

.vehicle-edit-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.vehicle-edit-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.vehicle-edit-row {
  display: flex;
  margin-bottom: 16px;
  padding-left: 40px;
  padding-right: 40px;
  gap: 16px;
}

.vehicle-detail-item {
  display: flex;
  align-items: center;
  flex: 1;
}

.vehicle-detail-label {
  font-weight: 500;
  color: #666;
  min-width: 100px;
}

.vehicle-detail-value {
  color: #333;
}
</style>